import { useState } from "react";

const ImageCarouselModal = ({ show, onClose, images }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 transition-opacity duration-300">
            <div className="relative w-11/12 max-w-xl mx-auto p-4 bg-white rounded-lg shadow-xl" onClick={e => e.stopPropagation()}>
                <button className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-3xl font-semibold leading-none z-50 transition-colors duration-200" onClick={onClose}>
                    &times;
                </button>
                <div className="flex justify-center items-center relative">
                    <button
                        onClick={prevImage}
                        className="absolute left-0 -ml-8 bg-gray-800 bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-75 transition-colors z-40"
                    >
                        &lt;
                    </button>
                    <img
                        src={images[currentImageIndex]}
                        alt="Product Carousel"
                        className="max-w-full max-h-[80vh] object-contain rounded-md"
                    />
                    <button
                        onClick={nextImage}
                        className="absolute right-0 -mr-8 bg-gray-800 bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-75 transition-colors z-40"
                    >
                        &gt;
                    </button>
                </div>
                <div className="flex justify-center mt-4 space-x-2">
                    {images.map((_, index) => (
                        <div
                            key={index}
                            className={`w-2 h-2 rounded-full cursor-pointer transition-colors ${index === currentImageIndex ? 'bg-blue-600' : 'bg-gray-400'}`}
                            onClick={() => setCurrentImageIndex(index)}
                        ></div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default ImageCarouselModal;